import { c } from 'react-compiler-runtime';
import { AlertIcon, GitMergeQueueIcon, IssueDraftIcon, GitPullRequestDraftIcon, GitMergeIcon, GitPullRequestClosedIcon, SkipIcon, IssueClosedIcon, GitPullRequestIcon, IssueOpenedIcon } from '@primer/octicons-react';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import classes from './StateLabel.module.css.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Octicon from '../Octicon/Octicon.js';

const octiconMap = {
  issueOpened: IssueOpenedIcon,
  pullOpened: GitPullRequestIcon,
  issueClosed: IssueClosedIcon,
  issueClosedNotPlanned: SkipIcon,
  pullClosed: GitPullRequestClosedIcon,
  pullMerged: GitMergeIcon,
  draft: GitPullRequestDraftIcon,
  issueDraft: IssueDraftIcon,
  pullQueued: GitMergeQueueIcon,
  unavailable: AlertIcon,
  open: null,
  closed: null
};
const labelMap = {
  issueOpened: 'Issue',
  pullOpened: 'Pull request',
  issueClosed: 'Issue',
  issueClosedNotPlanned: 'Issue, not planned',
  pullClosed: 'Pull request',
  pullMerged: 'Pull request',
  draft: 'Pull request',
  issueDraft: 'Issue',
  pullQueued: 'Pull request',
  unavailable: '',
  open: '',
  closed: ''
};
const StateLabel = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = c(20);
  let children;
  let className;
  let rest;
  let status;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      status,
      variant: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = status;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    status = $[4];
    t1 = $[5];
  }
  const variantProp = t1 === undefined ? "normal" : t1;
  const noIconStatus = status === "open" || status === "closed";
  let t2;
  if ($[6] !== className) {
    t2 = clsx(classes.StateLabel, className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== noIconStatus || $[9] !== status || $[10] !== variantProp) {
    t3 = !noIconStatus && /*#__PURE__*/jsx(Octicon, {
      "data-variant-small": variantProp === "small" ? "" : undefined,
      icon: octiconMap[status],
      "aria-label": labelMap[status],
      className: classes.Icon
    });
    $[8] = noIconStatus;
    $[9] = status;
    $[10] = variantProp;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== ref || $[14] !== rest || $[15] !== status || $[16] !== t2 || $[17] !== t3 || $[18] !== variantProp) {
    t4 = /*#__PURE__*/jsxs("span", {
      ...rest,
      ref: ref,
      className: t2,
      "data-variant": variantProp,
      "data-status": status,
      children: [t3, children]
    });
    $[12] = children;
    $[13] = ref;
    $[14] = rest;
    $[15] = status;
    $[16] = t2;
    $[17] = t3;
    $[18] = variantProp;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
});
StateLabel.displayName = 'StateLabel';

export { StateLabel as default };
